import { render, staticRenderFns } from "./IconEl.vue?vue&type=template&id=71facaed&scoped=true&"
import script from "./IconEl.vue?vue&type=script&lang=ts&"
export * from "./IconEl.vue?vue&type=script&lang=ts&"
import style0 from "./IconEl.vue?vue&type=style&index=0&id=71facaed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71facaed",
  null
  
)

export default component.exports